
<div class="material-datatable-wrapper">
  <app-datatable-headline
    [global_search_string]="global_search_string"
    [items_per_page_vars]="items_per_page_vars"
    (items_per_page_change)="itemPerPageChange($event)"
    (global_search_change)="onGlobalSearch($event)"
    [templateLeft]="additInputs"
    [templateRight]="buttonCreate">
  </app-datatable-headline>
  <div class="table-responsive">
    <table class="table table-striped datatable table-rwd">
      <thead app-data-table-head
        [sort]="sort"
        [columns]="columns"
        (sort_emmit)="onSortChange($event)">
      </thead>
      <tbody app-data-table-body
        (rowClick)="rowClick.emit($event)"
        [columns]="columns">
      </tbody>
    </table>
  </div>
  <app-datatable-pagination
    [current_page]="current_page"
    (change_page)="changePage($event)">
  </app-datatable-pagination>
</div>


<ng-template #buttonCreate>
  <button type="button" class="button button_sm" (click)="createNews()">
    Создать<span class="d-none d-md-inline"> новость</span>
  </button>
</ng-template>

<ng-template #additInputs>
  <app-material-input-checkbox [(ngModel)]="is_archive" [cssClass]="'mb-0'" [border]="true" [withMb0]="true">
    В архиве
  </app-material-input-checkbox>
  @if (!is_archive) {
    <span class="ml-2 mr-1 d-none d-lg-block">Тип публикации:</span>
  }
  @if (!is_archive) {
    <form [formGroup]="formGroup" novalidate>
      <app-material-select formControlName="public_status" [cssClass]="'mb-0'">
        <option [value]="''">Все</option>
        <option [value]="'crm'">СА</option>
        <option [value]="'site'">САЙТ</option>
        <!--      <option [value]="'site_crm'">САЙТ+СА</option>-->
      </app-material-select>
    </form>
  }
</ng-template>

<ng-template #urlTmpl let-row="row">
  <a class="link-break" href="{{row.news_url}}" target="_blank">{{row.news_url}}</a>
</ng-template>

<ng-template #pubTmpl let-row="row">
  @if (!row.is_archive && row.public_status == 'crm') {
    <span>СА</span>
  }
  @if (!row.is_archive && row.public_status == 'site') {
    <span>САЙТ</span>
  }
  @if (!row.is_archive && row.public_status == 'site_crm') {
    <span>САЙТ+СА</span>
  }
  @if (row.is_archive) {
    <span>Архив</span>
  }
  @if (row.always_show) {
    <div>
      <span class="badge badge-warning">Всегда всплывает</span>
    </div>
  }
  @if (row.is_view_news_list) {
    <div>
      <span class="badge badge-primary mt-1">Сводка</span>
    </div>
  }
  @if (row.is_view_vitrine) {
    <div>
      <span class="badge badge-success mt-1">Витрина</span>
    </div>
  }
</ng-template>

<ng-template #descriptionTmpl let-row="row">
  <div [textPreview]="50">
    <div [innerHtml]="row.news_description"></div>
  </div>
</ng-template>

<ng-template #nameTmpl let-row="row">
  {{row.news_title}}
  @if (row.is_archive) {
    <p class="font-weight-bold">Архив</p>
  }
</ng-template>

<ng-template #fileTmpl let-row="row">
  <div
    class = "banner_block"
    (click)="displayImage(row.file_url)"
    [style.background-image]="'url('+row.file_url+')'"
    >
  </div>
</ng-template>

<ng-template #buttonTmpl let-row="row">
  <div class="button button_icon my-2" (click)="editNews(row)">
    <i class="fa fa-pencil"></i>
  </div>
  @if (!row.is_archive) {
    <div class="button button_icon" (click)="deleteNews(row.news_id)">
      <i class="fa fa-trash"></i>
    </div>
  }
</ng-template>

<ng-template #tagsTmpl let-row="row">
  @if (row.tags) {
    <div>
      @for (tag of row.tags; track tag) {
        <span class="badge badge-info mr-1 mt-1">{{ tag.caption }}</span>
      }
    </div>
  }
</ng-template>


<ng-template #dateTmpl let-row="row">
  <div>
    <span class="text-sm">Создана: </span>
    <span class="">{{ row.create_time }}, </span>
    <span class="text-nowrap">{{ row.author_fio }}</span><br>
    <span class="text-sm">Изменена: </span>
    @if (row.change_time) {
      <span class="">{{ row.change_time }}, </span>
    }
    @if (row.change_fio) {
      <span class="text-nowrap">{{ row.change_fio }}</span>
    }
    @if (!row.change_time && !row.change_fio) {
      <span >&mdash;</span>
    }
  </div>
</ng-template>

<ng-template #viewsCountTmpl let-row="row">
  <div class="text-center">
    <span>{{ row.news_views_count }}</span>
  </div>
</ng-template>

<ng-template #viewsCountHead let-column="column">
  <i class="fa fa-fw fa-eye fa-align-center"></i>
</ng-template>
